import type { AiTag } from '@awork/_shared/models/tag.model'

export interface PromptContent {
  name: string
  description?: string
  text: string
}

export interface PromptSharing {
  workspaceAccessLevel: 'read' | 'manage' | null
  contributors: { userId: string; accessLevel: 'read' | 'manage' }[]
  teams: { teamId: string; accessLevel: 'read' | 'manage' }[]
}

export interface IAgentPrompt extends PromptContent {
  id: string
  createdOn?: string
  updatedOn?: string
  userId: string
  createdBy?: string
  accessLevel: 'read' | 'manage'
  workspaceAccessLevel?: 'read' | 'manage' | null
  isOwner: boolean
  hasAdminAccessOnly: boolean
  isOfficial?: boolean
  tags?: AiTag[]
  canEditTags?: boolean
  canSetOfficial?: boolean
}

export class AgentPrompt implements IAgentPrompt {
  id: string
  createdOn?: string
  updatedOn?: string

  name: string
  description?: string
  text: string

  userId: string
  createdBy?: string

  accessLevel: 'read' | 'manage'
  workspaceAccessLevel?: 'read' | 'manage' | null
  isOwner: boolean
  hasAdminAccessOnly: boolean
  isOfficial: boolean
  tags: AiTag[]
  canEditTags: boolean
  canSetOfficial: boolean

  /**
   * Creates a prompt from its API contract.
   * @param {Partial<IAgentPrompt>} prompt
   */
  constructor(prompt: Partial<IAgentPrompt>) {
    Object.assign(this, prompt)
    this.isOfficial = prompt.isOfficial ?? false
    this.tags = prompt.tags ?? []
    this.canEditTags = prompt.canEditTags ?? false
    this.canSetOfficial = prompt.canSetOfficial ?? false
  }
}
